import config from './config/runtime'

export function LOGO() {
    if (config.ENVIRONMENT === 'purplewave.net') {
        return '/img/purple_wave/ft-icon-color-white.png'
    } else {
        return '/img/purple_wave/ft-icon-color-white.png'
    }
}

export function LARGE_LOGO() {
    if (config.ENVIRONMENT === 'purplewave.net') {
        return '/img/purple_wave/ft-icon-color-white.png'
    } else {
        return '/img/purple_wave/ft-icon-color-white.png'
    }
}
